import PropTypes from 'prop-types';

function Arrow({
  width = 50,
  height = 24,
  strokeWidth = 2,
  className = '',
  ...rest
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none" // можно растягивать по ширине
      {...rest}
    >
      <path
        d="
      M2 12 H18
      M22 12 L18 15.5
      M22 12 L18 8.5
    "
        stroke="currentColor" // берёт цвет из className/CSS
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke" // толщина не распухает при растяжении
      />
    </svg>
  );
}

Arrow.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
};

export default Arrow;
